import { ref, Ref } from 'vue';
import { SPI, FormFieldWidget, ViewType, ModelFieldType, FormEnumFieldWidget, Widget } from '@kunlun/dependencies';
import { EnumerationValueFieldChangeEventBus } from '../changeValueStore';

type EnumerationValue = boolean | string;

export const fundAmountTypeChangeEventBus: Ref<EnumerationValueFieldChangeEventBus | undefined> = ref();

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    model: ['deli.aries.platform.fund.DeliAriesPlatformDisCreditFBLimitOrderProxy'],
    ttype: ModelFieldType.Enum,
    multi: false,
    name: 'fundAmountType'
  })
)
export class DisCreditFBLimitOrderModifyFundAmountTypeFieldWidget extends FormEnumFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    fundAmountTypeChangeEventBus.value = new EnumerationValueFieldChangeEventBus(this);
    return this;
  }

  @Widget.Method()
  change(val: EnumerationValue | null | undefined): void {
    super.change(val);
    fundAmountTypeChangeEventBus.value && fundAmountTypeChangeEventBus.value.publish(val);
  }
}
